var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"app-main-menu"},_vm._l((_vm.items),function(item){return _c(item.items ? 'app-main-menu-group' : 'app-main-menu-item',_vm._b({directives:[{name:"show",rawName:"v-show",value:(item.isVisible),expression:"item.isVisible"}],key:item.label,tag:"div"},'div',item,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }